module.exports = __webpack_public_path__ + "dimer/static/img/logo1.ea4d638.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/globalPartner/logo1.jpg
// module id = EGg+
// module chunks = 0